/* ==========================================================================
   Tanvika — product page behaviour

   Two things: the short description's View more / View less toggle, and the
   delivery timeline's dates.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Short description toggle

     The clamp itself is CSS, so the copy is correctly truncated on the very
     first paint with no script. This only adds the control.

     It is measured, not assumed: a description short enough to fit inside the
     clamp needs no toggle, and shipping one anyway gives the shopper a button
     that visibly does nothing. scrollHeight > clientHeight is the test — it
     only reports a difference while the element is actually overflowing, so
     it must run BEFORE the open class is applied.
     ---------------------------------------------------------------------- */

  function initDescription(root) {
    root.querySelectorAll('[data-tv-desc]').forEach(function (wrap) {
      var body = wrap.querySelector('[data-tv-desc-body]');
      var toggle = wrap.querySelector('[data-tv-desc-toggle]');
      if (!body || !toggle) return;

      // 2px of slack: sub-pixel line heights make scrollHeight exceed
      // clientHeight by a fraction on text that is not actually clipped.
      if (body.scrollHeight - body.clientHeight <= 2) {
        toggle.remove();
        wrap.classList.add('tv-pdp-desc--short');
        return;
      }

      var label = toggle.querySelector('[data-tv-desc-toggle-text]') || toggle;
      var more = toggle.getAttribute('data-label-more') || 'View more';
      var less = toggle.getAttribute('data-label-less') || 'View less';

      toggle.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        label.textContent = open ? less : more;
      });
    });
  }

  /* ------------------------------------------------------------------------
     Delivery timeline

     Rendered client-side rather than in Liquid because Shopify caches pages
     across requests: a Liquid-rendered "today" is the date the page was put
     in the cache, which can be days stale. The shopper's own clock is the
     only reliable source here.

     Business days only. Couriers do not despatch on Sunday, and quoting a
     Sunday delivery is a promise the store cannot keep.
     ---------------------------------------------------------------------- */

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) n--;
    }
    return d;
  }

  function fmt(d) {
    return MONTHS[d.getMonth()] + ' ' + String(d.getDate()).padStart(2, '0');
  }

  function range(a, b) {
    return fmt(a) === fmt(b) ? fmt(a) : fmt(a) + ' – ' + fmt(b);
  }

  function initTimeline(root) {
    root.querySelectorAll('[data-tv-timeline]').forEach(function (el) {
      var today = new Date();
      var procMin = parseInt(el.getAttribute('data-process-min'), 10) || 0;
      var procMax = parseInt(el.getAttribute('data-process-max'), 10) || 2;
      var shipMin = parseInt(el.getAttribute('data-ship-min'), 10) || 4;
      var shipMax = parseInt(el.getAttribute('data-ship-max'), 10) || 7;

      var slots = el.querySelectorAll('[data-tv-timeline-date]');
      if (slots.length < 3) return;

      slots[0].textContent = fmt(today);
      slots[1].textContent = range(addBusinessDays(today, procMin),
                                   addBusinessDays(today, procMax));
      slots[2].textContent = range(addBusinessDays(today, shipMin),
                                   addBusinessDays(today, shipMax));
    });
  }

  function init(root) {
    initDescription(root || document);
    initTimeline(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // The theme editor replaces section markup wholesale, which drops the
  // listeners bound above and leaves the toggle inert until reload.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Changing variant re-renders the product info column in Dawn, taking the
  // description and timeline with it.
  document.addEventListener('variant:change', function () { init(document); });
})();
